module.exports = __webpack_public_path__ + "img/img3.3a58fdfa.png";